import React from "react";
import "../css/Navbar.css"; // For styling

const AppLayout = ({ children }) => {
  return (
    <div className="app-layout">
      {children}
    </div>
  );
};

export default AppLayout;
